const css = `.progress-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2px;
}
.progress-container .progress-value {
  color: var(--text-muted);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xs);
  justify-content: center;
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: -16px;
}
.progress-container .p-progressbar {
  width: 100%;
  height: 12px;
}
.progress-container.error .p-progressbar {
  background-color: var(--danger-subtle);
  border-color: var(--danger);
}
.progress-container.error .p-progressbar .p-progressbar-value {
  background: var(--danger);
}
.progress-container.error .p-progressbar .p-progressbar-label {
  color: var(--danger);
}
.progress-container.warning .p-progressbar {
  background-color: var(--warning-subtle);
  border-color: var(--warning);
}
.progress-container.warning .p-progressbar .p-progressbar-value {
  background: var(--warning);
}
.progress-container.warning .p-progressbar .p-progressbar-label {
  color: var(--warning);
}
.progress-container.success .p-progressbar {
  background-color: var(--success-subtle);
  border-color: var(--success);
}
.progress-container.success .p-progressbar .p-progressbar-value {
  background: var(--success);
}
.progress-container.success .p-progressbar .p-progressbar-label {
  color: var(--success);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvUHJvZ3Jlc3MiLCJzb3VyY2VzIjpbIlByb2dyZXNzLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVGO0VBQ0U7RUFDQTs7QUFoQ0Y7RUFDRSxrQkFtQzBDO0VBbEMxQyxjQWtDMkI7O0FBakMzQjtFQUNFLFlBZ0N5Qjs7QUE5QjNCO0VBQ0UsT0E2QnlCOztBQXBDN0I7RUFDRSxrQkFzQzJDO0VBckMzQyxjQXFDMkI7O0FBcEMzQjtFQUNFLFlBbUN5Qjs7QUFqQzNCO0VBQ0UsT0FnQ3lCOztBQXZDN0I7RUFDRSxrQkF5QzJDO0VBeEMzQyxjQXdDMkI7O0FBdkMzQjtFQUNFLFlBc0N5Qjs7QUFwQzNCO0VBQ0UsT0FtQ3lCIiwic291cmNlc0NvbnRlbnQiOlsiQG1peGluIHByb2dyZXNzLXNldmVyaXR5KCRjb2xvciwgJGNvbG9yLWJnKSB7XG4gIC5wLXByb2dyZXNzYmFyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkY29sb3ItYmc7XG4gICAgYm9yZGVyLWNvbG9yOiAkY29sb3I7XG4gICAgLnAtcHJvZ3Jlc3NiYXItdmFsdWUge1xuICAgICAgYmFja2dyb3VuZDogJGNvbG9yO1xuICAgIH1cbiAgICAucC1wcm9ncmVzc2Jhci1sYWJlbCB7XG4gICAgICBjb2xvcjogJGNvbG9yO1xuICAgIH1cbiAgfVxufVxuXG4ucHJvZ3Jlc3MtY29udGFpbmVyIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBtYXJnaW4tdG9wOiAycHg7XG5cbiAgLnByb2dyZXNzLXZhbHVlIHtcbiAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LXNlbWlib2xkKTtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS14cyk7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgbGVmdDogMDtcbiAgICByaWdodDogMDtcbiAgICB0b3A6IC0xNnB4O1xuICB9XG4gIC5wLXByb2dyZXNzYmFyIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDEycHg7XG4gIH1cblxuICAmLmVycm9yIHtcbiAgICBAaW5jbHVkZSBwcm9ncmVzcy1zZXZlcml0eSh2YXIoLS1kYW5nZXIpLCB2YXIoLS1kYW5nZXItc3VidGxlKSk7XG4gIH1cbiAgJi53YXJuaW5nIHtcbiAgICBAaW5jbHVkZSBwcm9ncmVzcy1zZXZlcml0eSh2YXIoLS13YXJuaW5nKSwgdmFyKC0td2FybmluZy1zdWJ0bGUpKTtcbiAgfVxuICAmLnN1Y2Nlc3Mge1xuICAgIEBpbmNsdWRlIHByb2dyZXNzLXNldmVyaXR5KHZhcigtLXN1Y2Nlc3MpLCB2YXIoLS1zdWNjZXNzLXN1YnRsZSkpO1xuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
